module.exports = __webpack_public_path__ + "static/media/PricingImg.dc3632a6.svg";